import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { breakpoints } from '@chegg-ui/theme';
import { useMediaQuery } from 'react-responsive';
export var ScreenSize = /*#__PURE__*/function (ScreenSize) {
  ScreenSize["DESKTOP"] = "DESKTOP";
  ScreenSize["LAPTOP"] = "LAPTOP";
  ScreenSize["TABLET"] = "TABLET";
  ScreenSize["PHONE"] = "PHONE";
  return ScreenSize;
}({});
var getNumber = function getNumber(pixelString) {
  return Number.parseInt(pixelString);
};
export var screenSizeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ScreenSize.DESKTOP, getNumber(breakpoints.xl.min)), ScreenSize.LAPTOP, getNumber(breakpoints.lg.min)), ScreenSize.TABLET, getNumber(breakpoints.md.min)), ScreenSize.PHONE, getNumber(breakpoints.sm.min));
var useScreenBreakpoints = function useScreenBreakpoints() {
  var isDesktop = useMediaQuery({
    minWidth: screenSizeMap.DESKTOP
  });
  var isLaptop = useMediaQuery({
    minWidth: screenSizeMap.LAPTOP
  });
  var isTablet = useMediaQuery({
    minWidth: screenSizeMap.TABLET
  });
  var isPhone = useMediaQuery({
    minWidth: screenSizeMap.PHONE
  });
  switch (true) {
    case isDesktop:
      return ScreenSize.DESKTOP;
    case isLaptop:
      return ScreenSize.LAPTOP;
    case isTablet:
      return ScreenSize.TABLET;
    case isPhone:
    default:
      return ScreenSize.PHONE;
  }
};
export default useScreenBreakpoints;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/hooks/useScreenBreakpoint.js
// module id = 1505
// module chunks = 11